import React from 'react';
import SettingsSection from './SettingsSection';

const AddCalendar = () => {
    
    return (
        <div className='planner-settings'>
                
            <SettingsSection add={true} />   

        </div>
    );
};

export default AddCalendar;